<form name="internalTransferForm" novalidate>
  <div class="domp-to-section m-10">
    <div class="row">
      <div class="col-sm-6 col-xs-6">
        <div class="form-group">
          <label class="domp-form-label-review" translate="transactionDivision.amount"></label>
          <label class="d-block domp-form-label-resume">{{transactionDivision.postResponseObj.amount | number: 2}} BAM</label>
        </div>
      </div>
      <div class="col-sm-6">
        <label class="domp-form-label-review" translate="transactionDivision.cardNumber">Card number</label>
        <label class="d-block domp-form-label-resume">
          {{transactionDivision.postResponseObj.cardNumber}}
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <label class="domp-form-label-review" translate="transactionDivision.creatorName">Creator name</label>
        <label class="d-block domp-form-label-resume">
          {{transactionDivision.postResponseObj.creatorName}}
        </label>
      </div>
      <div class="col-sm-6">
        <label class="domp-form-label-review" translate="transactionDivision.transLocation">Transaction
          location</label>
        <label
          class="d-block domp-form-label-resume">{{transactionDivision.postResponseObj.transactionLocation}}</label>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <label class="domp-form-label-review" translate="transactionDivision.status">Status</label>
        <label class="d-block domp-form-label-resume">{{'transactionDivision.'+transactionDivision.postResponseObj.status | translate}}</label>
      </div>
      <div class="col-sm-6 col-xs-6">
        <div class="form-group">
          <label class="domp-form-label-review" translate="transactionDivision.installmentNumber"></label>
          <label
            class="d-block domp-form-label-resume">{{transactionDivision.postResponseObj.installmentNumber}}</label>
        </div>
      </div>
    </div>
  </div>

  <div class="domp-to-section m-10">
    <div class="row">
      <div class="col-sm-6 col-xs-6">
        <div class="form-group">
          <label class="domp-form-label-review" translate="transactionDivision.creationDate"></label>
          <label class="d-block domp-form-label-resume">{{transactionDivision.postResponseObj.creationDate | date:
            'shortDate'}}</label>
        </div>
      </div>
      <div class="col-sm-6 col-xs-6">
        <div class="form-group">
          <label class="domp-form-label-review" translate="transactionDivision.transactionDate"></label>
          <label class="d-block domp-form-label-resume">{{transactionDivision.postResponseObj.valueDate | date:
            'shortDate'}}</label>
        </div>
      </div>
    </div>
  </div>
  <div class="m-10">
    <div class="row">
      <div class="col-sm-9 p-b-10 col-xs-12 hidden-xs">
        <button class="btn btn-primary " translate="currencyConversion.back"
                data-ng-click="transactionDivision.new();">
        </button>
        <button class="btn btn-primary" translate="payments.edit"
                data-ng-click="transactionDivision.edit();">
        </button>
        <button class="btn btn-primary-warning " translate="payments.delete"
                data-ng-click="transactionDivision.delete();">
        </button>
      </div>

      <div class="col-sm-9 p-b-10 col-xs-12 visible-xs-block">
        <button class="btn btn-default btn-block"
                translate="currencyConversion.sign"
                data-ng-click="transactionDivision.sign()">
        </button>
        <button class="btn btn-primary btn-block" translate="currencyConversion.back"
                data-ng-click="transactionDivision.new();">
        </button>
        <button class="btn btn-primary btn-block" translate="payments.edit"
                data-ng-click="transactionDivision.edit();">
        </button>
        <button class="btn btn-primary-warning btn-block" translate="payments.delete"
                data-ng-click="transactionDivision.delete();">
        </button>
      </div>

      <div class="col-sm-3 col-xs-12 hidden-xs">

        <button class="btn btn-default col-xs-12"
                translate="currencyConversion.sign"
                data-ng-click="transactionDivision.sign()">
        </button>


      </div>
    </div>
  </div>

</form>


